import React, { memo } from 'react';
import { withNativeProps } from '../../utils/native-props';
export var SpokesIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    style: {
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "1",
    d: "M24 4C25.064 4 25.875 4.90041 25.875 5.96441L25.875 12.2895C25.875 13.2688 24.9793 14 24 14C23.0207 14 22.125 13.2688 22.125 12.2895L22.125 5.96441C22.125 4.90041 22.936 4 24 4Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.92",
    d: "M34.1352 6.75427C35.0472 7.29142 35.2884 8.468 34.7592 9.38464L31.5955 14.8643C31.1016 15.7198 29.9532 15.9036 29.1042 15.3987C28.2705 14.9028 27.8631 13.829 28.3481 12.9889L31.5117 7.50937C32.0469 6.58241 33.2129 6.21107 34.1352 6.75427Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.075s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.84",
    d: "M41.3632 14.0673C41.8913 14.9886 41.5172 16.1417 40.5976 16.6726L35.1188 19.8358C34.2669 20.3277 33.177 19.9008 32.689 19.0466C32.2059 18.2009 32.3982 17.0764 33.2417 16.5894L38.7221 13.4253C39.6461 12.8919 40.8325 13.1417 41.3632 14.0673Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.15s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.76",
    d: "M44 24C44 25.064 43.0996 25.875 42.0356 25.875L35.7105 25.875C34.7312 25.875 34 24.9793 34 24C34 23.0207 34.7312 22.125 35.7105 22.125L42.0356 22.125C43.0996 22.125 44 22.936 44 24Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.225s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.68",
    d: "M41.3631 33.9317C40.8325 34.8573 39.646 35.1071 38.722 34.5737L33.2417 31.4096C32.3982 30.9226 32.2058 29.7981 32.6889 28.9524C33.177 28.0982 34.2668 27.6713 35.1188 28.1632L40.5975 31.3264C41.5171 31.8573 41.8912 33.0104 41.3631 33.9317Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.3s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.6",
    d: "M34.1354 41.2451C33.2131 41.7883 32.0472 41.417 31.512 40.49L28.3484 35.0105C27.8634 34.1705 28.2707 33.0966 29.1044 32.6008C29.9534 32.0958 31.1018 32.2796 31.5957 33.1351L34.7594 38.6148C35.2886 39.5314 35.0474 40.708 34.1354 41.2451Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.375s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.52",
    d: "M24 44C22.936 44 22.125 43.0996 22.125 42.0356L22.125 35.7105C22.125 34.7312 23.0207 34 24 34C24.9793 34 25.875 34.7312 25.875 35.7105L25.875 42.0356C25.875 43.0996 25.064 44 24 44Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.45s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.44",
    d: "M14.1217 41.3947C13.1925 40.8659 12.9403 39.6768 13.4749 38.7508L16.6392 33.2701C17.1243 32.4298 18.2425 32.2352 19.0872 32.7126C19.9469 33.1984 20.379 34.2925 19.8853 35.1476L16.7222 40.6264C16.1924 41.544 15.0427 41.9189 14.1217 41.3947Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.525s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.36",
    d: "M12.96 28.298C13.8032 27.8112 14.8814 28.2237 15.3752 29.0629C15.8742 29.9111 15.6881 31.0531 14.8358 31.5451L9.3561 34.7089C8.4375 35.2392 7.25828 34.9957 6.72284 34.0801C6.18368 33.158 6.55577 31.9955 7.48077 31.4615L12.96 28.298Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.6s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.28",
    d: "M5.96441 25.875C4.90041 25.875 4 25.064 4 24C4 22.936 4.90041 22.125 5.96441 22.125L12.2895 22.125C13.2688 22.125 14 23.0207 14 24C14 24.9793 13.2688 25.875 12.2895 25.875L5.96441 25.875Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.675s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.2",
    d: "M6.72284 13.9193C7.25827 13.0037 8.43749 12.7602 9.3561 13.2905L14.8358 16.4542C15.6881 16.9463 15.8742 18.0883 15.3752 18.9365C14.8814 19.7757 13.8032 20.1882 12.96 19.7013L7.48077 16.5379C6.55577 16.0039 6.18368 14.8414 6.72284 13.9193Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.75s"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.12",
    d: "M14.1221 6.60605C15.043 6.08195 16.1927 6.45678 16.7225 7.37444L19.8856 12.8532C20.3794 13.7083 19.9471 14.8025 19.0874 15.2883C18.2428 15.7656 17.1246 15.571 16.6395 14.7307L13.4752 9.24997C12.9406 8.32401 13.1928 7.1349 14.1221 6.60605Z",
    fill: "white"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: "1",
    to: ".12",
    dur: "0.9s",
    repeatCount: "indefinite",
    begin: "0.825s"
  }))));
});